import DapDSOverlay from './overlay.component'

export * from './overlay.component'
export default DapDSOverlay

DapDSOverlay.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-overlay': DapDSOverlay
  }
}
